import React, {Component} from 'react'
import locale from './locale'
import moment from 'moment'
import Loading from 'components/UI/Loading'
import classnames from 'classnames';
import { connect } from 'react-redux';
import ReactTimeline from 'components/UI/ReactTimeline'
import TimelineForm from './TimelineForm';
import OnBoardingNatural from 'template/OnBoardingNatural';
import { onBoardingContents } from './constant';
import __R from 'containers/__R'

import {getSubscriptionAction} from 'actions/School/SchoolAction'
import {fetchStudentTimeline, resetTimelineCache} from './redux/actions/getStudentTimeline'
import {fetchStudentTimelineYear} from './redux/actions/getStudentTimelineYear'
import {updateTimelineTask} from './redux/actions/updateTimelineTask'
import {createTimelineTask} from './redux/actions/createTimelineTask'
import {deleteTimelineTask} from './redux/actions/deleteTimelineTask'

import './Timeline.scss'

const AMOUNT_PER_PAGE_PERLOAD = 10;

const mapStateToProps = (state) => ({
  user: state.user,
  gSubscription: state.gSubscription,
  timeline: state.timelineReducer,
})

const mapDispatchToProps = (dispatch) => {
  return {
    fetchStudentTimeline: (studentId, opts, callback) => dispatch(fetchStudentTimeline(studentId, opts, callback)),
    fetchStudentTimelineYear: (studentId, callback) => dispatch(fetchStudentTimelineYear(studentId, callback)),
    createTimelineTask: (studentId, taskInfo, callback) => dispatch(createTimelineTask(studentId, taskInfo, callback)),
    updateTimelineTask: (index, taskId, taskInfo, type, callback) => dispatch(updateTimelineTask(index, taskId, taskInfo, type, callback)),
    deleteTimelineTask: (index, taskId, callback) => dispatch(deleteTimelineTask(index, taskId, callback)),
    resetTimelineCache: () => dispatch(resetTimelineCache()),
    getSubscription: () => dispatch(getSubscriptionAction()),
	}
}

class Timeline extends Component{
  constructor(props){
    super(props)

    this.state = {
      toggledYearMenu: {1: true},

      showTypeToggles: {
        recent: true,
        completed: false,
        pending: false
      },

      viewMode: 'timeline',
      years: [],
      amount_per_page: {
        completed: AMOUNT_PER_PAGE_PERLOAD,
        pending: AMOUNT_PER_PAGE_PERLOAD,
        recent: AMOUNT_PER_PAGE_PERLOAD,
        year: AMOUNT_PER_PAGE_PERLOAD,
      }
    }

    this.toggleYearmenu = this.toggleYearmenu.bind(this);
    this.onSubmitAdd = this.onSubmitAdd.bind(this);
    this.editTask = this.editTask.bind(this);
    this.cancel = this.cancel.bind(this);
    this.onSubmitUpdate = this.onSubmitUpdate.bind(this);
  }

  componentDidMount(){
    const {studentId, timeline} = this.props
    const {recent} = this.state.amount_per_page

    this.props.fetchStudentTimeline(studentId, {amount_per_page: recent, current_page_number: 1, recent: 1})
    this.props.fetchStudentTimelineYear(studentId)
  }

  componentWillUnmount() {
    this.props.resetTimelineCache();
  }

  toggleYearmenu(toggleYear) {
    const {studentId} = this.props
    const {recent, year} = this.state.amount_per_page


    return ()=>{
      if(Object.keys(this.state.toggledYearMenu) != toggleYear){

        if(toggleYear == 1){
          this.props.fetchStudentTimeline(studentId, {amount_per_page: recent, current_page_number: 1, recent: 1})
        } else {
          this.props.fetchStudentTimeline(studentId, {amount_per_page: year, current_page_number: 1, year: toggleYear})
        }

        this.setState({
          toggledYearMenu: {
            [toggleYear]: this.state.toggledYearMenu[toggleYear] !== true,
          },
          showCompleted: false,
          showUpcoming: false,
          showRecent: true,
        });
      }
    }
  }

  onSubmitAdd(toSubmit) {
    const {createTimelineTask, studentId} = this.props;
    const {recent} = this.state.amount_per_page


    createTimelineTask(studentId, toSubmit, ()=>{
      this.setState({
        viewMode: "timeline"
      });

      this.props.fetchStudentTimeline(studentId, { amount_per_page: recent, current_page_number: 1, recent: 1 })
      this.props.fetchStudentTimelineYear(studentId)

    });
  }

  onSubmitUpdate(toSubmit) {
    const {updateTimelineTask, studentId} = this.props;
    const {taskToEditIndex, amount_per_page} = this.state;
    const {recent} = amount_per_page
    const id = toSubmit.id;

    delete toSubmit.id;

    updateTimelineTask(taskToEditIndex, id, toSubmit, '', ()=>{
      this.setState({
        viewMode: "timeline"
      });

      this.props.fetchStudentTimeline(studentId, { amount_per_page: recent, current_page_number: 1, recent: 1 })
      this.props.fetchStudentTimelineYear(studentId)

    });
  }

  editTask(task, taskToEditIndex) {
    let taskToEdit = {
      ...task,
    }

    if (task.teacher_id_assigned_to && task.teacher_name_assigned_to) {
      // convert data for the Form to understand
      taskToEdit.assigned_to = [
        {
          id: task.teacher_id_assigned_to,
          tName: task.teacher_name_assigned_to,
        }
      ];
    }

    // convert date format for the Form to understand
    taskToEdit.due_datetime = taskToEdit.due_datetime ? moment(taskToEdit.due_datetime).format('YYYY-MM-DD HH:mm') : undefined;
    taskToEdit.remind_at = taskToEdit.remind_at ? moment(taskToEdit.remind_at).format('YYYY-MM-DD HH:mm') : undefined;

    delete taskToEdit.teacher_id_assigned_to;
    delete taskToEdit.teacher_name_assigned_to;

    this.setState({
      viewMode: 'edit',
      taskToEdit,
      taskToEditIndex,
    });
  }

  cancel() {
    this.setState({viewMode: 'timeline'});
  }

  render(){
    const {
      toggledYearMenu,
      showCompleted,
      showUpcoming,
      showRecent,
      viewMode,
      taskToEdit,
      amount_per_page
    } = this.state;

    const {studentId, timeline, gSubscription, studentInfo} = this.props
    const {list, fetching, year_list, formWorking, pagination} = timeline
    const {completed, pending, recent, year} = amount_per_page
    const content = onBoardingContents;
    const role = localStorage.getItem('role')

    if (!year_list || !pagination){
      return (
        <div className='timeline-container'>
          <Loading />
        </div>
      );
    }

    const renderSection = (type, title, fetchOpts)=>{
      const showThisType = this.state.showTypeToggles[type];

      return (
          <section className='eventType'>
              <div
                className='eventTypeToggle'
                onClick={()=>{
                  const toggle = showThisType !== true;

                  this.setState({
                    showTypeToggles: {
                      [type]: toggle,
                    }
                  });

                  if (toggle) {
                    this.props.fetchStudentTimeline(studentId, {amount_per_page: amount_per_page[type], current_page_number: 1, ...fetchOpts})
                  }

                }}
                >{title}
                {showThisType === true && <i className='fa icon-angle-up'></i>}
                {showThisType !== true && <i className='fa icon-angle-down'></i>}
              </div>
              <hr />
              <ReactTimeline
                type={type}
                tasks={list}
                showTimeline={showThisType === true}
                editTask={this.editTask}
                updateTask={this.props.updateTimelineTask}
                deleteTask={this.props.deleteTimelineTask}
                fetching={fetching}
              />
              {(pagination.totalItemsCount > pagination.itemsCountPerPage && showThisType) && <div className='text-center'>
              <a onClick={() => {
                this.setState({
                  amount_per_page: {
                    ...this.state.amount_per_page,
                    recent: recent + 10
                  }
                }, () => {
                  this.props.fetchStudentTimeline(studentId, {amount_per_page: amount_per_page[type], current_page_number: 1, recent: 1})
                })
              }}>{__('Load More', locale)}</a>
            </div>}
          </section>
       );
    }

    const showOnBoarding = pagination.totalItemsCount <= 0 && year_list.length <= 1;

      return (
        <div className='timeline-container'>
          {
            viewMode === 'add' && <TimelineForm
              title={__('Create Task', locale)}
              formData={{}}
              loading={formWorking}
              onSubmit={this.onSubmitAdd}
              triggerCancel={this.cancel}
            />
          }
          {
            viewMode === 'edit' && <TimelineForm
              title={__('Edit Task', locale)}
              formData={taskToEdit}
              loading={formWorking}
              onSubmit={this.onSubmitUpdate}
              triggerCancel={this.cancel}
            />
          }
          {
            /* timeline ---> */
          }
          <div className={classnames('timeline', { 'active': viewMode == 'timeline' })}>
            <__R can='create_student_task' by='disable'>
              <button className='btn btn-primary add-event pull-right' disabled={studentInfo.state === 2} onClick={()=>{
                this.setState({
                  viewMode: 'add',
                });
              }}>{__('Add Task', locale)}
              </button>
            </__R>
            <div className='timeline-title'>{__('Planning', locale)}</div>
          {
            showOnBoarding &&
            <OnBoardingNatural
              isShown={true}
              title={content.title}
              text={content.text}
              image={content.image}
              showArrow={content.showArrow}
            />
          }
          { showOnBoarding !== true &&
            <div className='row'>
              <div className='col-xs-1' style={{marginTop: '32px', paddingRight: '0px'}}>
                <ul>
                  {year_list.map((year, key) => {
                    return(
                      <li
                        key={key}
                        className={classnames('event-year', { "active": toggledYearMenu[year] == true })}
                        onClick={this.toggleYearmenu(year)}>
                        {year == 1 ? __('Recent', locale) : year}
                      </li>
                    )
                  })}
                </ul>
              </div>
              <div className='col-xs-10' style={{paddingLeft: '0px'}}>
                <div className='eventColumn'>
                  {renderSection('completed', __('Completed', locale), { state: 1 })}
                  {renderSection('pending', __('Pending', locale), { state: 0 })}
                  {renderSection('recent', Object.keys(toggledYearMenu) == 1 ? __('Recent', locale) : Object.keys(toggledYearMenu), { recent: 1 })}
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Timeline)



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/Timeline/index.js